<script>
export default {
  name: "HomeForm",
  components: {},

  data: () => ({
    validMail: false,
    // Campos: Nome completo, E-mail, telefone corporativo, Cargo, Nome da empresa, Site da empresa, tamanho da empresa -->
    form: {
      fullName: "",
      email: "",
      phone: "",
      position: "",
      company: "",
      site: "",
      size: "",
    },
    terms: false,
    initialSelectState: true,
  }),
  methods: {
    validateEmail() {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)
      ) {
        this.validMail = false;
      } else {
        this.validMail = true;
      }
    },
    checkForm() {
      if (
        this.form.fullName !== "" &&
        this.form.email &&
        this.form.phone &&
        this.form.position &&
        this.form.company &&
        this.form.site &&
        this.form.size &&
        this.terms &&
        !this.validMail
      ) {
        return false;
      }
      return true;
    },
    submitForm() {
      //TODO validar os vampos
      this.axios
        .post("/lead/add", this.form)
        .then((response) => {
          // rediciona para a página de quiz
          this.$router.push({
            name: "Quiz",
            // query: { leadId: response.data.id }
          });

          // adiciona o id do lead na sessão
          this.$store.commit("SET_LEAD_ID", response.data.id);
          this.$store.commit("SET_CURRENT_USER", this.form);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    companySizeChanged(event) {
      this.initialSelectState = false;
    },
  },
};
</script>
<template>
  <div id="HomeForm">
    <form action="" ref="form" name="MetaDXIEn">
      <div class="form-title">
        See your company’s digital maturity diagnosis.
      </div>
      <div class="form-group w-full">
        <label for="nome">Full Name*</label>
        <input
          type="text"
          class="form-control"
          id="fullName"
          name="fullName"
          placeholder="Type your name"
          v-model="form.fullName"
        />
      </div>
      <div class="form-group w-full">
        <label for="email">Corporate e-mail*</label>
        <input
          @blur="validateEmail"
          type="email"
          class="form-control"
          id="email"
          name="email"
          placeholder="Type your e-mail"
          v-model="form.email"
        />
        <span v-if="validMail" class="invalid-field">E-mail inválido</span>
      </div>
      <div class="form-group w-4/12">
        <label for="telefone">Phone*</label>
        <input
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          type="text"
          class="form-control"
          id="phone"
          name="phone"
          placeholder="(00) 00000-0000"
          v-model="form.phone"
        />
      </div>
      <div class="form-group w-8/12 pl-15px">
        <label for="cargo">Job role*</label>
        <input
          type="text"
          class="form-control"
          id="position"
          name="position"
          placeholder="Type your job role"
          v-model="form.position"
        />
      </div>
      <div class="form-group w-full">
        <label for="empresa">Company name*</label>
        <input
          type="text"
          class="form-control"
          id="company"
          name="company"
          placeholder="Type your company name"
          v-model="form.company"
        />
      </div>
      <div class="form-group w-7/12">
        <label for="site">Company website*</label>
        <input
          type="text"
          class="form-control"
          id="site"
          name="site"
          placeholder="Type your company website"
          v-model="form.site"
        />
      </div>
      <div class="form-group w-5/12 pl-15px empresa-select">
        <label for="tamanho">Company size*</label>
        <select
          name="size"
          id="size"
          v-bind:class="{ initialSelectState: initialSelectState }"
          @change="companySizeChanged($event)"
          v-model="form.size"
          class="form-control"
        >
          <option value="" disabled selected hidden>Choose one</option>
          <option value="1-49 employees">1-49 employees</option>
          <option value="50-199 employees">50-199 employees</option>
          <option value="200-499 employees">200-499 employees</option>
          <option value="500-999 employees">500-999 employees</option>
          <option value="1,000-4,999 employees">
            1,000-4,999 employees
          </option>
          <option value="5,000-9,999 employees">
            5,000-9,999 employees
          </option>
          <option value="More than 10,000 employees">
            More than 10,000 employees
          </option>
        </select>
      </div>
      <div class="form-group w-full">
        <div class="form-check politica-wrapper">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="defaultCheck1"
            name="privacyPolitics"
            v-model="terms"
          />
          <label class="form-check-label pl-15px" for="defaultCheck1">
            We are committed to protecting your privacy and ensuring that your
            personal information is secure. I agree with Meta’s
            <b
              ><a
                href="https://meta.com.br/politica-de-privacidade/"
                target="_blank"
              >
                Privacy Policy</a
              ></b
            >
            da Meta.
          </label>
        </div>
      </div>
      <button
        class="button-28"
        role="button"
        type="submit"
        @click.stop.prevent="submitForm()"
        :disabled="checkForm()"
      >
        START
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </form>
  </div>
</template>
